export default __webpack_public_path__ + "static/media/music-light-6.ec71ca92.svg";